import React from 'react';
import PropTypes from 'prop-types';
import {
  TextSmall,
  TextCaption,
  IconClose,
  Direction,
  Column
} from '@scotia/canvas-react';
import { SubtitleTool } from '../Typography';
import { Alignment } from '../Alignment';
import style from './Tooltip.scss';

class Tooltip extends React.Component {
  constructor() {
    super();
    this.leftPosition = 0;
    this.pullLeft = -24;
    this.pullArrowLeft = '35%';
    this.state = {
      isVisible: false,
      width: 0
    };
  }

  Offset(el) {
    const rect = el.getBoundingClientRect();
    const bodyWidth = window.innerWidth;
    const widthBeforeArrow = 106;
    const widthAfterArrow = 210;
    const widthArrow = 16;
    const widthTooltip = 332;
    const contentWidth = el.clientWidth;

    // Right viewport border case
    if (
      rect.left +
        (rect.right - rect.left) / 2 +
        widthArrow / 2 +
        widthAfterArrow >
      bodyWidth
    ) {
      this.pullLeft = -(
        widthTooltip -
        (bodyWidth - rect.left) -
        widthBeforeArrow +
        30
      );
      const locationArrow =
        ((rect.left + contentWidth / 2 - (bodyWidth - widthTooltip)) /
          widthTooltip) *
          100 +
        1;
      this.pullArrowLeft = locationArrow + '%';
    }

    // Left viewport border case
    if (
      rect.left +
        (rect.right - rect.left) / 2 -
        widthArrow / 2 -
        widthBeforeArrow <
      0
    ) {
      this.pullLeft = widthBeforeArrow - (rect.right - contentWidth) - 20;
      const locationArrow =
        (((rect.right - rect.left) / 2 + rect.left) / widthTooltip) * 100 - 2;
      this.pullArrowLeft = locationArrow + '%';
    }
    const scrollLeft =
      window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
  }

  showModal() {
    const elem = document.getElementById('tooltip-scotiaweb-close');
    elem && elem.click();
    const width = this.divElement.clientWidth;
    this.setState({
      isVisible: true,
      width: width
    });
    const divOffset = this.Offset(this.divElement);
    this.leftPosition = divOffset.left;
  }

  hideModal(e) {
    e.stopPropagation();
    this.setState({
      isVisible: false
    });
  }

  render() {
    const windowWidth = window.innerWidth;
    const mobileResolution = windowWidth < 430;
    return (
      <div
        className={style['tooltip']}
        onClick={this.props.onClick ? () => this.showModal() : null}
        onMouseEnter={this.props.onClick ? null : () => this.showModal()}
        ref={divElement => (this.divElement = divElement)}
      >
        {this.state.isVisible ? (
          <div
            className={style['tooltiptext']}
            style={
              mobileResolution
                ? {
                    width: windowWidth - 32,
                    right:
                      '-' +
                      (windowWidth -
                        this.leftPosition -
                        this.state.width -
                        16) +
                      'px'
                  }
                : { width: '33.2rem', left: this.pullLeft }
            }
          >
            <div
              className={style['tooltiparrow']}
              style={
                mobileResolution
                  ? { left: this.leftPosition - 16 + this.state.width / 2 }
                  : { left: this.pullArrowLeft }
              }
            />
            <Direction type="row">
              <Column md={10} xs={10}>
                <Alignment xs="left" md="left">
                  <SubtitleTool>{this.props.title}</SubtitleTool>
                </Alignment>
              </Column>
              <Column
                md={2}
                xs={2}
                id="tooltip-scotiaweb-close"
                onClick={e => this.hideModal(e)}
                style={{ height: '100%', textAlign: 'right' }}
              >
                <IconClose size={18} />
              </Column>
              <Column md={12} xs={12} style={{ marginTop: '0.8rem' }}>
                <Alignment xs="left" md="left">
                  <TextCaption style={{ lineHeight: '1.8rem' }}>
                    {this.props.text}
                  </TextCaption>
                </Alignment>
              </Column>
            </Direction>
          </div>
        ) : null}
        {this.props.children}
      </div>
    );
  }
}

Tooltip.propTypes = {
  /** Title to be shown on the top */
  title: PropTypes.string.isRequired,
  /** Text to be shown on the content */
  text: PropTypes.string.isRequired,
  /** Select true if you need shown the Tooltip onClick */
  onClick: PropTypes.bool,
  /** Item to insert the Tooltip*/
  children: PropTypes.node.isRequired
};

Tooltip.defaultProps = {
  onClick: true
};

export { Tooltip };
